export enum MessageActionButtonsAlignment {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
}
